export default __webpack_public_path__ + "static/media/organizzazione-dark.69268921.svg";